<!-- cv简历信息表-爱好与特长-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail en'>
        <h4 class='pad-top'>Language Proficiency</h4>
        <div v-if='hobbyDetailEn.languages && hobbyDetailEn.languages.length > 0'>
          <ul v-for='(item, index) in hobbyDetailEn.languages'
              :key='index'>
            <li>
              <span class='cv-detail-name'>Language：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Proficiency：</span>
              <span class='cv-detail-val'>{{item.proficiency && new Map(proficiencyEnMap).get(item.proficiency)}}</span>
            </li>
          </ul>
        </div>
        <h4 class='pad-top'>Talents and Hobbies</h4>
        <div v-if='hobbyDetailEn.hobbies && hobbyDetailEn.hobbies.length > 0'>
          <ul v-for='(item, index) in hobbyDetailEn.hobbies'
              :key='index'>
            <li>
              <span class='cv-detail-name'>Name：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Pro Training：</span>
              <span class='cv-detail-val'>{{item.proTraining && new Map(proTrainingEnMap).get(item.proTraining)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Started Since：</span>
              <span class='cv-detail-val'>{{item.startTime}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Weeks per Year：</span>
              <span class='cv-detail-val'>{{item.weeksPerYear}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Hours per Week：</span>
              <span class='cv-detail-val'>{{item.hoursPerWeek}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import { proficiencyEnMap, proTrainingEnMap } from '../constants'
import './cv-detail.less'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 熟练程度映射
      proficiencyEnMap,
      // 是否专业训练映射
      proTrainingEnMap,
      // 学员num
      menteeNum: '',
      // 活动详情
      hobbyDetailEn: {}
    }
  },
  computed: {},
  mounted () {
    this.menteeNum = this.$route.params.id
    this.getHobbyDetailEn()
  },
  methods: {
    // 获取爱好与特长-en
    getHobbyDetailEn () {
      cvService.cvHobbyDetailEn({ num: this.menteeNum }).then(res => {
        if (res.data.model) {
          this.hobbyDetailEn = res.data.model
          if (this.hobbyDetailEn.hobbies) {
            for (let i = 0; i < this.hobbyDetailEn.hobbies.length; i++) {
              this.hobbyDetailEn.hobbies[i].proTraining = (this.hobbyDetailEn.hobbies[i].proTraining || String(this.hobbyDetailEn.hobbies[i].proTraining) === 'false') ? String(this.hobbyDetailEn.hobbies[i].proTraining) : ''
            }
          }
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
